export enum AuctionPostbackStatusEnum {
    Won = 1,
    Lost = 2,
    Withdrawn = 3,
    ReOffered = 4
}
